import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-black-icon",
  "use": "icon-play-black-icon-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play-black-icon\">\n<path d=\"M3.34375 4.83794C3.344 3.3086 4.99642 2.34995 6.32422 3.10747L6.32324 3.10844L19.0098 10.3389L19.3408 10.5284V10.5723C20.4206 11.4885 20.3091 13.2654 19.0107 14.0069H19.0098L6.32324 21.2383C4.99538 21.9957 3.34375 21.0373 3.34375 19.5079V4.83794Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol